const AUTO_SLIDE_BEHAVIOUR = {
  OFF: 'OFF',
  INTERVAL: 'INTERVAL',
  CONTINUOUS: 'CONTINUOUS',
};

export default AUTO_SLIDE_BEHAVIOUR;
